/* VetPro Klaviyo Client API helper — email + optional SMS opt-in.
   Reused by the email-capture section and the quiz. Public key (company_id / site ID) is
   safe to expose; NEVER put a private key in the theme.

   IMPORTANT (SMS): collecting a number here only registers consent in Klaviyo. Texts do NOT
   send until the owner completes Klaviyo SMS setup: an active SMS plan, a provisioned sending
   number (US = 10DLC brand + campaign registration), and an SMS flow. Until then this is inert.
   The consent checkbox + TCPA disclosure copy in the markup is DRAFT — legal must confirm. */
(function () {
  'use strict';

  // Best-effort E.164 normalisation (US-centric). Returns null if it can't make a plausible number.
  function normalizePhone(raw) {
    if (!raw) return null;
    var s = String(raw).trim();
    var hasPlus = s.charAt(0) === '+';
    var digits = s.replace(/[^0-9]/g, '');
    if (hasPlus) { return digits.length >= 8 && digits.length <= 15 ? '+' + digits : null; }
    if (digits.length === 10) return '+1' + digits;            // US 10-digit
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits; // US with country code
    if (digits.length >= 8 && digits.length <= 15) return '+' + digits;        // fall back, assume includes country code
    return null;
  }

  // Subscribe a profile. opts: { companyId, listId, email, phone, smsConsent, source, properties }
  // Returns a Promise. Requires companyId + listId. Email OR a valid phone is required.
  function subscribe(opts) {
    opts = opts || {};
    var key = opts.companyId, list = opts.listId;
    if (!key || !list) return Promise.reject(new Error('Klaviyo company_id and list_id are required'));

    var email = (opts.email || '').trim();
    var phone = opts.smsConsent ? normalizePhone(opts.phone) : null;
    if (!email && !phone) return Promise.reject(new Error('An email or a valid phone number is required'));

    var attrs = {};
    if (email) attrs.email = email;
    if (phone) attrs.phone_number = phone;
    if (opts.properties) attrs.properties = opts.properties;

    // NOTE: the client subscriptions endpoint rejects a `subscriptions` block on the
    // profile — it is a server-API field. Posting here is itself the consent action,
    // so email consent is recorded without it. SMS consent needs Klaviyo's own form
    // or a server-side call; sending a phone here only stores the number.

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: opts.source || 'VetPro site',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('Klaviyo subscribe failed (' + r.status + ')');
      return { ok: true, sms: !!phone };
    });
  }

  // Progressive-enhancement binder for any <form data-vp-klaviyo> with:
  //   data-company-id, data-list-id, data-source; inputs [name=email], [name=phone],
  //   [name=sms_consent] (checkbox). Shows [data-vp-k-success] / [data-vp-k-error] on finish.
  function bindForms() {
    document.querySelectorAll('form[data-vp-klaviyo]').forEach(function (form) {
      if (form.dataset.vpKlaviyoBound) return;
      form.dataset.vpKlaviyoBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (form.querySelector('[name="email"]') || {}).value || '';
        var phoneEl = form.querySelector('[name="phone"]');
        var consentEl = form.querySelector('[name="sms_consent"]');
        var btn = form.querySelector('[type="submit"]');
        var ok = form.querySelector('[data-vp-k-success]');
        var err = form.querySelector('[data-vp-k-error]');
        if (ok) ok.hidden = true; if (err) err.hidden = true;
        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Signing you up…'; }
        subscribe({
          companyId: form.dataset.companyId,
          listId: form.dataset.listId,
          source: form.dataset.source || 'Email capture',
          email: email,
          phone: phoneEl ? phoneEl.value : '',
          smsConsent: consentEl ? consentEl.checked : false
        }).then(function (res) {
          form.reset();
          if (ok) { ok.hidden = false; ok.textContent = res.sms ? 'You’re in — your 15% code is on its way to your inbox (and check your phone too).' : 'You’re in — your 15% code is on its way to your inbox.'; }
        }).catch(function () {
          if (err) { err.hidden = false; err.textContent = 'Something went wrong. Please try again.'; }
        }).then(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Sign up'; }
        });
      });
    });
  }

  window.VPKlaviyo = { subscribe: subscribe, normalizePhone: normalizePhone, bindForms: bindForms };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindForms);
  else bindForms();
})();
